import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m20.957 7.457.707-.707-1.414-1.414-.707.707 1.414 1.414zM9.75 17.25l-.707.707.707.707.707-.707-.707-.707zm-4.543-5.957-.707-.707L3.086 12l.707.707 1.414-1.414zm14.336-5.25-10.5 10.5 1.414 1.414 10.5-10.5-1.414-1.414zm-9.086 10.5-5.25-5.25-1.414 1.414 5.25 5.25 1.414-1.414z",
		fill: "currentColor"
	})
});
export default SvgCheck;
